import styled, { keyframes } from 'styled-components';
import { focusOutline } from '../../utility-classes';
import { HeartIcon } from '../Icons/Icon/Heart';
const bounceAnimation = keyframes `
  15% {
    transform: scale(0.85);
  }
  50% {
    transform: scale(1.25);
  }
  60%: {
    transform: scale(0.9);
  }
`;
export const Button = styled.button `
  width: 50px;
  aspect-ratio: 18 / 16;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${o => o.theme.spacing(1)};
  -webkit-tap-highlight-color: transparent;
  ${focusOutline};

  /* Define the color that will be inherited by the icon elements. */
  color: ${o => o.theme.color.button.primary.fill.on.background};

  /* Define the animation that will be restarted on click */
  animation: ${bounceAnimation} 0.15s ease-in-out 1;

  /* Define transform & opacity transition for hover/disabled states */
  transition:
    0.2s ease-out transform,
    0.15s ease-out opacity;
  transform-origin: center;

  &:hover {
    transform: scale(1.125);
  }
  &[aria-disabled] {
    opacity: 0.5;
    pointer-events: none;
  }

  > * {
    flex-basis: auto;
    flex-grow: 0;
    flex-shrink: 0;
  }
`;
export const Icon = styled(HeartIcon) `
  display: block;
`;
export const IconFill = styled(HeartIcon.Fill) `
  transition: 0.1s ease-out opacity;
  opacity: ${o => (o.$filled ? 1 : 0)};
`;
//# sourceMappingURL=styles.js.map